export enum LogLevel {
  Debug = 'debug',
  Info = 'info',
  Error = 'error',
}

class Logger {
  public logLevel: LogLevel;

  constructor(logLevel?: LogLevel) {
    if (logLevel) {
      this.logLevel = logLevel;
    } else {
      this.logLevel = LogLevel.Error;
    }
  }

  public logDebug(message: any) {
    if (this.logLevel === LogLevel.Debug) {
      console.info(Logger.freezeMessage(message));
    }
  }

  public logInfo(message: any) {
    if (this.logLevel === LogLevel.Debug || this.logLevel === LogLevel.Info) {
      console.info(Logger.freezeMessage(message));
    }
  }

  public logError(err: Error) {
    console.error(Logger.freezeMessage(err.message));
  }

  private static freezeMessage(message: any): string {
    return JSON.parse(JSON.stringify(message));
  }
}

const logger = new Logger();
export default logger;
